import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Content from "../../components/content/Content";
import ContentBody from "../../components/content/ContentBody";
import ContentHead from "../../components/content/ContentHead";
import { faTrash } from "@fortawesome/free-solid-svg-icons";
import { Component } from "react";
import withRouter from "../../components/withRouter/withRouter";
import InputField from "../../components/inputField/inputField";
import { getHomeData, updateHomeData, uploadImageApi } from "../../api";
import toast from "react-hot-toast";

class AddUpdateClient extends Component {
  state = {
    imageUrl: "",
    imageObject: "",
    imageCaption: "",
    imageAlt: "",
    name: "",
    linkUrl: "",
    heroData: [],
    _id: "",
    loading: true,
  };

  componentDidMount = () => {
    this.getData();
  };

  getData = async () => {
    getHomeData()
      .then((res) => {
        if (this.props.router.params?.id) {
          let val = {};

          if (res.data[0].client.length === 1) {
            val = res.data[0].client[0];
          } else {
            val = res.data[0].client.filter(
              (vv) => vv._id === this.props.router.params.id
            )[0];
          }

          this.setState({
            imageUrl: val?.clientImage,
            imageCaption: val?.clientImageCaption,
            imageAlt: val?.clientImageAlt,
            name: val?.clientName,
            linkUrl: val?.linkUrl,
          });
        }

        this.setState({
          _id: res.data[0]?._id,
          heroData: res.data[0]?.client,
          loading: false,
        });
      })
      .catch((err) => {});
  };

  uploadImage = async () => {
    if (this.state.imageObject) {
      try {
        const response = await uploadImageApi(
          this.state.imageObject,
          "technology"
        );

        return response.data.imageUrl;
      } catch (error) {
        console.log(error);
        throw error;
      }
    }
    return this.state.imageUrl;
  };

  validate = () => {
    if (!this.state.imageUrl) {
      toast.error("Image is required.");
      return false;
    }
    if (!this.state.imageCaption) {
      toast.error("Image Caption is required.");
      return false;
    }
    if (!this.state.imageAlt) {
      toast.error("Image Alt is required.");
      return false;
    }
    if (!this.state.name) {
      toast.error("Name is required.");
      return false;
    }
    if (!this.state.linkUrl) {
      toast.error("Link Url is required.");
      return false;
    }

    return true;
  };

  handleImage = (event) => {
    this.setState({
      imageUrl: URL.createObjectURL(event.target.files[0]),
      imageObject: event.target.files[0],
    });
  };

  handleUpdate = () => {
    if (this.validate()) {
      this.setState({ loading: true });

      this.uploadImage().then((r) => {
        const data = {
          clientImage: r,
          clientImageCaption: this.state.imageCaption,
          clientImageAlt: this.state.imageAlt,
          clientName: this.state.name,
          linkUrl: this.state.linkUrl,
        };

        let hero = [];

        if (this.props.router.params?.id && this.state.heroData.length > 1) {
          hero = this.state.heroData.map((val) => {
            if (val._id === this.props.router.params?.id) {
              return { ...data };
            }
            return val;
          });
        } else if (
          this.props.router.params?.id &&
          this.state.heroData.length <= 1
        ) {
          hero = [{ ...data }];
        } else {
          hero = [...this.state.heroData, { ...data }];
        }

        updateHomeData({ client: hero }, this.state._id)
          .then((res) => {
            console.log(res);
            toast.success(
              this.props.router.params?.id
                ? "Updated Successfully."
                : "Added Successfully."
            );
            this.props.router.navigate("/");
          })
          .catch((err) => {
            console.log(err);
            toast.error("Something went wrong");
            this.setState({ loading: false });
          });
      });
    }
  };

  render() {
    return (
      <>
        {this.state.loading && (
          <div
            style={{
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              background: "rgba(0,0,0,.3)",
              zIndex: 100000,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <span className="loader"></span>
          </div>
        )}
        <Content>
          <ContentHead
            title={
              this.props.router?.params?.id ? "Update Client" : "Add Client"
            }
            showBtn1={true}
            btn1Text="Save"
            btn1Name="btn1"
            btn1type="filled"
            showBtn2={true}
            btn2Text="Cancel"
            btn2Name="btn2"
            btn2type="outlined_del"
            onClickHandler={(e) => {
              if (e.target.name === "btn1") {
                this.handleUpdate();
              } else this.props.router.navigate("/");
            }}
          />
          <ContentBody>
            <div className="grid">
              <div className="card grid">
                <div>
                  <p
                    style={{
                      fontSize: "16px",
                      fontWeight: 500,
                      transform: "translateX(5px)",
                      marginBottom: "10px",
                    }}
                  >
                    Client Image
                    <span
                      style={{ color: "#a3a3a3", fontSize: ".8rem" }}
                    ></span>
                    {this.state.imageUrl && (
                      <span
                        style={{
                          display: "inline-flex",
                          borderRadius: "10px",
                          marginLeft: "10px",
                          color: "#CB1829",
                          cursor: "pointer",
                          alignItems: "center",
                        }}
                        onClick={() => {
                          this.setState({ imageUrl: "", imageObject: "" });
                        }}
                        title="Delete image"
                      >
                        <FontAwesomeIcon icon={faTrash} />
                      </span>
                    )}
                  </p>

                  {!this.state.imageUrl ? (
                    <div
                      style={{
                        height: "50px",
                        width: "50px",
                        textAlign: "center",
                        background: "transparent",
                        border: "1px dashed grey",
                        borderRadius: "10px",
                        cursor: "pointer",
                        position: "relative",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      +
                      <input
                        type="file"
                        style={{
                          opacity: 0,
                          position: "absolute",
                          top: 0,
                          bottom: 0,
                          right: 0,
                          left: 0,
                          cursor: "pointer",
                        }}
                        accept="image/*"
                        onChange={this.handleImage}
                      ></input>
                    </div>
                  ) : (
                    <div style={{ width: "45%", marginBottom: "40px" }}>
                      <div
                        style={{
                          width: "100%",
                          aspectRatio: "16/9",
                          backgroundImage: `url('${
                            this.props.router.params.id
                              ? this.state.isImageChanged
                                ? this.state.imageUrl
                                : this.state.imageUrl
                              : this.state.imageUrl
                          }')`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          marginTop: "10px",
                          borderRadius: "15px",
                          position: "relative",
                        }}
                      ></div>
                      {this.state.imageObject && (
                        <p style={{ textAlign: "center" }}>
                          {this.state.imageObject.name}
                        </p>
                      )}
                    </div>
                  )}
                </div>
                {this.state.imageUrl && (
                  <div className="grid_2">
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Caption"}
                      value={this.state.imageCaption}
                      onChange={(e) =>
                        this.setState({ imageCaption: e.target.value })
                      }
                    />
                    <InputField
                      type="text"
                      isLabel={true}
                      lable={"Image Alt"}
                      value={this.state.imageAlt}
                      onChange={(e) =>
                        this.setState({ imageAlt: e.target.value })
                      }
                    />
                  </div>
                )}
                <div className="grid">
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Client Name"}
                    value={this.state.name}
                    onChange={(e) => this.setState({ name: e.target.value })}
                  />
                  <InputField
                    type="text"
                    isLabel={true}
                    lable={"Link Url"}
                    value={this.state.linkUrl}
                    onChange={(e) => this.setState({ linkUrl: e.target.value })}
                  />
                </div>
              </div>
            </div>
          </ContentBody>
        </Content>
      </>
    );
  }
}

export default withRouter(AddUpdateClient);
